import React from 'react'
import FunnelHeader from '../shared/FunnelHeader'
import FunnelSubHeader from '../shared/FunnelSubheader'

interface Props {
  header: string
  subtitle?: string
}

const MarketplaceHeader = ({header, subtitle}: Props): JSX.Element => {
  return (
    <>
      <FunnelHeader text={header} />
      {subtitle && <FunnelSubHeader text={subtitle} />}
    </>
  )
}

export default MarketplaceHeader
